import React, { FC, useEffect, useState } from "react";
// import { useHistory } from 'react-router-dom';
import {
  Col,
  Row,
  Spin,
  Image,
  Card,
  Rate,
  Select,
  Checkbox,
  Space,
} from "antd";
import styled from "styled-components";
import { useLazyQuery } from "@apollo/client";
import { GET_ALL_PRINTERS } from "../Apollo/graphql/Query";
import Img3D from "../Components/Model3D";
import HeaderComponent from "../Components/HeaderComponents";
import FooterPublic3D from "../Components/FooterPublic3D";
import InfiniteScroll from "react-infinite-scroll-component";
import SearchIcon from "../assets/images/searchIcon.png";
import { Button3D } from "../Components/Button3D";
import { Input3D } from "../Components/Input3D";
import NullDataComp from "../Components/NullDataComp";

const { Option } = Select;

const ContentWrapper = styled(Row)`
  margin-bottom: "2rem";
  /* margin-top: 1.25rem; */
`;
const SubHeader = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row;
  padding: 5px;
  justify-content: space-between;
  margin-top: 10px;
  background: white;
  box-shadow: 0 5px 5px rgba(182, 182, 182, 0.75);

  .ant-select-selector {
    border: none !important;
  }

  .small-text {
    font-size: 10px;
    font-weight: 700;
  }
`;
const ContentSection = styled(Col)`
  width: 100%;
  padding-bottom: 2rem;
`;
const ContentDivX = styled(Col)`
  display: flex;
  justify-content: center;
  margin-top: 2rem;
`;
const IconBox = styled(Image)`
  height: 20px;
  width: 20px;
  margin-right: 10px;
`;
const RowX = styled(Row)`
  margin: 2rem;
`;
const CardX = styled(Card)`
  display: flex;
  flex-direction: column;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.08);

  .ant-card-cover {
    height: 250px;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    display: flex;
  }
  .ant-card-body {
    padding: 1rem;
  }

`;
const Img = styled.img`
  display: inline-block;
  width: auto;
  max-width: 100%;
  height: 100%;
  object-fit: contain;
  /* max-inline-size: 100%;
  block-size: auto;
  aspect-ratio: 2/1;
  object-fit: cover;   */
`;
const InfoDiv = styled.div`
  display: flex;
  flex-direction: column;
  .info-text {
    /* text-transform: capitalize; */
  }
  .div-filament {
    margin-left: 0.5rem;
  }
`;
const CheckGroupBox = styled.div``;

const PublicPrinters: FC = () => {
  // const [printers, setPrinters] = useState([]);
  const [loadedPrinters, setLoadedPrinters] = useState<any>([]);
  const [searchValue, setSearchValue] = useState<any>();
  const [filterValues, setFilterValues] = useState<any>([]);
  const [sortValues, setSortValues] = useState<any>("popular");
  const [selectedMaterial, setSelectedMaterials] = useState<any>([]);
  const [totalPrinters, setTotalPrinters] = useState<any>(null);
  const [queryVariables, setQueryVariables] = useState<any>({});
  const PAGE_LIMIT = 20;
  // const history = useHistory();

  const [getPrinters, { loading }] = useLazyQuery(GET_ALL_PRINTERS, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      // setPrinters(data?.printers?.printers);
      // setLoadedPrinters(data?.printers?.printers?.slice(0, 20));
      if (data?.printers?.pagination?.page === 1) {
        setLoadedPrinters([...data?.printers?.printers]);
      } else {
        setLoadedPrinters([...loadedPrinters, ...data?.printers?.printers]);
      }
      setTotalPrinters(data?.printers?.pagination?.total);
    },
    onError: (err) => {
      console.log(err);
    },
  });

  const loadPrinters = (variables) => {
    getPrinters({
      variables,
    });
  };

  useEffect(() => {
    const variables = {};
    variables["pagination"] = {
      page: 1,
      limit: PAGE_LIMIT,
    };
    if (filterValues.length > 0) {
      variables["filter"] = {
        material: filterValues,
      };
    }
    if (searchValue && searchValue.length > 0) {
      variables["filter"] = {
        ...variables["filter"],
        search: searchValue
      }
    }
    if (sortValues === "popular") {
      variables["sort"] = {
        popularity: "desc",
      };
    }
    setQueryVariables({ ...variables });
    loadPrinters({ ...variables });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterValues, sortValues]);

  const handleFilterClick = () => {
    const variables = {};
    variables["pagination"] = {
      page: 1,
      limit: PAGE_LIMIT,
    };
    if (filterValues.length > 0) {
      variables["filter"] = {
        material: filterValues,
      };
    }
    if (searchValue && searchValue.length > 0) {
      variables["filter"] = {
        ...variables["filter"],
        search: searchValue
      }
    }
    if (sortValues === "popular") {
      variables["sort"] = {
        popularity: "desc",
      };
    }
    setQueryVariables({ ...variables });
    loadPrinters({ ...variables });
  };

  const loadMore = () => {
    if (!totalPrinters) {
      return;
    }
    if (loadedPrinters.length < totalPrinters) {
      const variables = { ...queryVariables };
      variables.pagination.page = queryVariables.pagination.page + 1;
      loadPrinters({ ...variables });
    }
  };
  const onChange = (value: string) => {
    console.log(`selected ${value}`);
  };
  const onSortChange = (value: string) => {
    setSortValues(value);
  };

  const onCheckboxChange = (e: any) => {
    setSelectedMaterials(e);
    setFilterValues(e);
  };

  return (
    <Spin spinning={loading}>
      <ContentWrapper>
        <HeaderComponent />
        <div style={{ width: "100%", background: "#F7F7F7" }}>
          <ContentSection span={20} offset={2}>
            <ContentDivX>
              <Input3D
                onChange={(e) => setSearchValue(e.target.value)}
                prefix={<IconBox src={SearchIcon} alt="" />}
              />
              <Button3D
                type="primary"
                style={{
                  height: "50px",
                  width: "9rem",
                  color: "white",
                  marginLeft: "10px",
                }}
                onClick={handleFilterClick}
              >
                Search
              </Button3D>
            </ContentDivX>
            <SubHeader>
              <div>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <div className="small-text">MATERIALS</div>
                  <div>
                    <Select
                      placeholder={
                        selectedMaterial.length !== 0
                          ? `${selectedMaterial.toString()}`
                          : `All`
                      }
                      onChange={onChange}
                      dropdownMatchSelectWidth={false}
                      dropdownRender={() => (
                        <CheckGroupBox>
                          <Checkbox.Group onChange={onCheckboxChange}>
                            <Space
                              direction="vertical"
                              style={{ padding: "0 10px" }}
                            >
                              <Checkbox value="ABS">ABS</Checkbox>
                              <Checkbox value="PLA">PLA</Checkbox>
                              <Checkbox value="PLA_PLUS">PLA+</Checkbox>
                              <Checkbox value="PET">PET</Checkbox>
                              <Checkbox value="PETG">PETG</Checkbox>
                              <Checkbox value="RESIN">RESIN</Checkbox>
                              <Checkbox value="NYLON">NYLON</Checkbox>
                              <Checkbox value="NYLON_CARBON_FIBER">
                                NYLON CARBON FIBER
                              </Checkbox>
                              <Checkbox value="TPU">TPU</Checkbox>
                              <Checkbox value="HIPS">HIPS</Checkbox>
                              <Checkbox value="PVA">PVA</Checkbox>
                              <Checkbox value="SANDSTONE">SANDSTONE</Checkbox>
                              <Checkbox value="CERAMICS">CERAMICS</Checkbox>
                              <Checkbox value="STEEL">STEEL</Checkbox>
                              <Checkbox value="WOOD">WOOD</Checkbox>
                              <Checkbox value="POLYCARBONATE">
                                POLYCARBONATE
                              </Checkbox>
                            </Space>
                          </Checkbox.Group>
                        </CheckGroupBox>
                      )}
                    ></Select>
                  </div>
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div className="small-text">SORT BY</div>
                <div>
                  <Select
                    // placeholder="Popular"
                    onChange={onSortChange}
                    dropdownMatchSelectWidth={false}
                    defaultValue="Popular"
                  >
                    <Option value="popular">Popular</Option>
                    <Option value="newest">Recent</Option>
                    {/* <Option value="tom">Price - High to Low</Option>
                                        <Option value="price">Price - Low to High</Option> */}
                  </Select>
                </div>
              </div>
            </SubHeader>
            <InfiniteScroll
              dataLength={loadedPrinters.length}
              next={loadMore}
              hasMore={true}
              loader=""
              style={{ margin: "2rem 0", overflow: "unset" }}
              scrollableTarget="scrollableDiv"
            >
              <RowX gutter={[32, 32]}>
                {/* {
                                    loading && loadedPrinters.map((printer: any) => {
                                        return (
                                            <Col xl={{ span: 6 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                                                <Skeleton3D />
                                            </Col>
                                        )
                                    })
                                } */}
                {loadedPrinters.length === 0 && <NullDataComp />}
                {loadedPrinters &&
                  loadedPrinters.map((printer: any) => {
                    return (
                      <Col
                        xl={{ span: 6 }}
                        md={{ span: 12 }}
                        sm={{ span: 24 }}
                        xs={{ span: 24 }}
                        key={printer._id}
                      >
                        <a href={`/printers/${printer._id}`}>
                          <CardX
                            loading={false}
                            cover={
                              printer?.featuredImage?.endsWith(".stl") ? (
                                <Img3D url={printer?.featuredImage} />
                              ) : (
                                <Img src={printer?.featuredImage} alt="" />
                              )
                            }
                          >
                            <InfoDiv>
                              <div>
                                <strong className="info-text">
                                  {printer?.name}
                                </strong>
                              </div>
                              <div>
                                <span className="info-text">
                                  Brand: {printer?.brand}
                                </span>
                              </div>
                              <div>
                                <span className="info-text">
                                  {printer?.length} X {printer?.width} X{" "}
                                  {printer?.height}
                                </span>
                              </div>
                              <div>
                                <div className="info-text">
                                  {"Filaments & Price(/gram):"}
                                </div>
                                <div
                                  style={{ display: "flex", flexWrap: "wrap" }}
                                >
                                  {printer?.filaments.map((sf: any, idx) => {
                                    return (
                                      <span key={idx}>
                                        {/* {sf.name}: {`$${sf.price},`} */}
                                        {sf.name === "PLA_PLUS"
                                          ? "PLA+"
                                          : sf.name.replaceAll("_", " ")}
                                        : {`$${sf.price},`}
                                      </span>
                                    );
                                  })}
                                </div>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  flexFlow: "row",
                                  justifyContent: "space-between",
                                }}
                              >
                                <span className="info-text">
                                  Location: {printer?.postalAddress || ""}{" "}
                                  {printer?.countryCode || ""}
                                </span>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  flexFlow: "row",
                                  justifyContent: "space-between",
                                }}
                              >
                                <span className="info-text">
                                  by: {printer?.owner?.firstName}
                                </span>
                              </div>

                              <hr
                                style={{
                                  width: "100%",
                                  border: "1px solid #D8D8D8",
                                }}
                              />
                              <span>
                                Rating:{" "}
                                <Rate
                                  defaultValue={printer?.averageStarRating}
                                  style={{ paddingLeft: "1rem" }}
                                  disabled
                                ></Rate>
                              </span>
                            </InfoDiv>
                            {/* <hr />
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                        }}
                                                    >
                                                        <CommentOutlined
                                                            style={{
                                                                fontSize: "1.2rem",
                                                                marginRight: 10,
                                                            }}
                                                        />
                                                        {"0"}
                                                        <span style={{ marginLeft: 5 }}>Comments</span>
                                                    </div> */}
                          </CardX>
                        </a>
                      </Col>
                    );
                  })}
              </RowX>
            </InfiniteScroll>
          </ContentSection>
        </div>
        <FooterPublic3D />
      </ContentWrapper>
    </Spin>
  );
};

export default PublicPrinters;
